import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import '../../sass/mainv3.scss'

function SublinkGroup({ parentComponent, subLinks, handleWindowReload, topbar }) {
  const sublinksType = links => {
    const { url, title, isExternalLink, segmentEvent, payload } = links
    const payloadJSON = payload ? JSON.parse(payload.internal.content) : {}
    if (isExternalLink) {
      return (
        <a
          className="sub-navigation__link"
          href={links.url}
          data-event={links.title.toLowerCase()}
          onClick={() => {
            if (segmentEvent && window.analytics) {
              window.analytics.track(segmentEvent, {
                location: parentComponent,
                text: title,
                destination: url,
                url: window.location.href,
                ...payloadJSON
              })
            }
          }}
        >
          {links.title}
        </a>
      )
    }
    return (
      <Link
        className="sub-navigation__link"
        to={links.url}
        data-event={links.title.toLowerCase()}
        onClick={() => {
          if (segmentEvent && window.analytics) {
            window.analytics.track(segmentEvent, {
              location: parentComponent,
              text: title,
              destination: `${process.env.GATSBY_BASE_URL}${url}`,
              url: window.location.href,
              ...payloadJSON
            })
          }
          handleWindowReload(links.url)
        }}
      >
        {links.title}
      </Link>
    )
  }
  return (
    subLinks && (
      <div className={topbar ? 'sub-navigation top-bar-sub-nav' : 'sub-navigation'}>
        <ul
          className={topbar ? 'sub-navigation__list top-bar-sub-nav-list' : 'sub-navigation__list'}
        >
          {subLinks.map(links => {
            return (
              <li className="sub-navigation__item" key={links.title}>
                {sublinksType(links)}
              </li>
            )
          })}
        </ul>
      </div>
    )
  )
}

SublinkGroup.defaultProps = {
  topbar: false,
  parentComponent: ''
}

SublinkGroup.propTypes = {
  subLinks: PropTypes.array.isRequired,
  handleWindowReload: PropTypes.func.isRequired,
  topbar: PropTypes.bool,
  parentComponent: PropTypes.string
}

export default SublinkGroup
